// extracted by mini-css-extract-plugin
export default {"icon":"ConfigFileManagement_icon__jXOfW","tip":"ConfigFileManagement_tip__OMBwd","typeTip":"ConfigFileManagement_typeTip__ujREM"};